$('.assembly-icon').each(function () {
    let lines = $(this).data('lines');

    for (let i = 0; i < lines; i++) {
        $(this).append(
            $('<span/>').addClass('assembly-icon__item')
        );
    }
});
